import {
  Button, Grid, MenuItem, Select,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import {
  EquipmentRequestTableColumns, InventoryManagementTableColumns, REQUEST, inventoryContent, sendEquipmentType,
} from './utils/constants';
import inventoryImage from '../../assets/Images/InventoryManagement/InventoryRequest.gif';
import sendEquipmentImage from '../../assets/Images/InventoryManagement/sendRequest.gif';
import requestEquipmentImage from '../../assets/Images/InventoryManagement/requestEquipment.gif';
import EndPoints from '../../Routes/EndPoints';
import {
  getEquipmentRequestDataStart,
  onDeleteEquipmentByAdmin, resetInventoryEquipmentRequest, setEquipmentRequestTab,
} from './TestEquipmentRequestScreen/redux/equipmentRequestSlice';
import { setLoader } from '../../redux/loaderSlice';
import { RootState } from '../../redux/rootState';
import { EquipmentRequestListData, UpcomingJobsEquipmentList } from './utils/types';
import './Style.scss';
import { formatEquipmentRequestListData } from './utils/helper';
import ComponentDeleteModal from '../../Common/DeleteModal/ComponentDeleteModal';
import { getUpcomingJobsStart } from './InventoryLandingPage/redux/inventorySlice';
import { convertDateFormat } from '../../utils/CommonFunctions';

export default function InventoryManagement() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const { isLoading, equipmentRequestData } = useSelector((state: RootState) => state.inventoryEquipmentRequestReducer);
  const { upcomingJobsData, isLoadingUpcomingJobs } = useSelector((state: RootState) => state.inventoryReducer);
  const [searchQuery, setSearchQuery] = useState('');
  const [jobFilter, setJobFilter] = useState('upcoming');

  const handleData = () => {
    const payload = {
      page: 1,
      searchQuery,
      rowsPerPage: 4,
      IsUpcoming: jobFilter === 'upcoming',
    };
    dispatch(getUpcomingJobsStart(payload));
  };

  useEffect(() => {
    dispatch(setLoader(isLoading || isLoadingUpcomingJobs));
  }, [isLoading, isLoadingUpcomingJobs]);

  const handleEquipmentRequestData = () => {
    const payload = {
      page: 1,
      searchQuery: '',
      rowsPerPage: 4,
      sortCol: '',
      sortDir: 'asc',
    };
    dispatch(getEquipmentRequestDataStart(payload));
  };

  const handleDelete = (id: string) => {
    setDeleteModal(true);
    setSelectedId(id);
  };

  const handleDeleteModal = () => {
    dispatch(onDeleteEquipmentByAdmin({ selectedId, callback: handleEquipmentRequestData }));
    setDeleteModal(false);
  };

  useEffect(() => {
    handleEquipmentRequestData();
    handleData();
  }, []);
  useEffect(() => {
    handleData();
  }, [jobFilter]);

  const handleButtonClick = () => {
    dispatch(resetInventoryEquipmentRequest());
    navigate(EndPoints.TEST_EQUIPMENT_REQUEST_FORM);
  };

  const handleEdit = (id: string) => {
    dispatch(setEquipmentRequestTab(REQUEST));
    const roleValue = equipmentRequestData?.Data?.find((element) => element?.RequestId === id);
    navigate(`${EndPoints.TEST_EQUIPMENT_REQUEST_FORM}/${id}/${roleValue?.RoleId}`);
  };

  const upcomingJobsListData: UpcomingJobsEquipmentList[] = useMemo(() => upcomingJobsData?.Data?.map((item) => {
    const transformedDataItems = {
      product: item?.ProductNumber,
      description: item?.Description,
      location: item?.Location,
      job: item?.JobNumber,
      startDate: convertDateFormat(item?.StartDate),
      endDate: convertDateFormat(item?.EndDate),
      analyst: item?.Analyst,
      id: item?.ProductNumber,
    };
    return transformedDataItems;
  }), [upcomingJobsData]);

  return (
    <>
      <ComponentPageHeader subHeading="Inventory Management" />
      <div className="div_job_container_info customBodyWithoutBtnContainer">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className="headingDataTable" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>Equipment needed for upcoming Jobs</div>
              <div className="save_and_next_div">
                <Select
                  style={{ width: '220px' }}
                  size="small"
                  value={jobFilter}
                  onChange={(e) => setJobFilter(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: '220px', // Adjust the max height value as needed
                        maxWidth: '220px',
                      },
                    },
                  }}
                >
                  <MenuItem className="menu-item-enter" value="upcoming">
                    Upcoming Jobs
                  </MenuItem>
                  <MenuItem className="menu-item-enter" value="all">
                    All Jobs
                  </MenuItem>
                </Select>
              </div>
            </div>

            <DataTable<UpcomingJobsEquipmentList>
              data={upcomingJobsListData}
              totalRecords={10}
              columns={InventoryManagementTableColumns}
              handleData={handleData}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
            />
            {/* {upcomingJobsData?.Data?.length > 0
              && (
                <div className="save_and_next_div bottomButtons">
                  <Button onClick={() => navigate(EndPoints.EQUIPMENT_NEEDED_FOR_JOBS)} className="button_save_and_next">View All</Button>
                </div>
              )} */}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={7}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
              >
                <div onClick={() => navigate(EndPoints.INVENTORY_LANDING_PAGE)} className="inventoryCards">
                  <div className="inventoryContent">
                    <div className="textInventory">INVENTORY</div>
                    <div className="textDescriptionInventory">
                      {inventoryContent.inventory}
                    </div>
                  </div>
                  <div className="inventoryImage">
                    <img
                      className="imageSize"
                      src={inventoryImage}
                      alt="inventoryImage"
                    />
                  </div>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
              >
                <div onClick={() => navigate(`/${EndPoints.SEND_EQUIPMENT_SCREEN}/${sendEquipmentType.SEND_EQUIPMENT}`)} className="inventoryCards">
                  <div className="inventoryContent">
                    <div className="textInventory">SEND EQUIPMENT</div>
                    <div className="textDescriptionInventory">
                      {inventoryContent.sendEquipment}
                    </div>
                  </div>
                  <div className="inventoryImage">
                    <img
                      className="imageSize"
                      src={sendEquipmentImage}
                      alt="inventoryImage"
                    />
                  </div>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
              >
                <div
                  className="inventoryCards"
                  onClick={() => navigate(`/${EndPoints.SEND_EQUIPMENT_SCREEN}/${sendEquipmentType.RECEIVE_EQUIPMENT}`)}
                >
                  <div className="inventoryContent">
                    <div className="textInventory">RECEIVE EQUIPMENT</div>
                    <div className="textDescriptionInventory">
                      {inventoryContent.receivedEquipment}
                    </div>
                  </div>
                  <div className="inventoryImage">
                    <img
                      className="imageSize"
                      src={requestEquipmentImage}
                      alt="inventoryImage"
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={5}>
            <div className="equipmentRequestContainer">
              <div className="headingDataTable">EQUIPMENT REQUEST</div>
              <DataTable<EquipmentRequestListData>
                data={equipmentRequestData?.Data?.length > 0 ? formatEquipmentRequestListData(equipmentRequestData?.Data) : []}
                columns={EquipmentRequestTableColumns}
                totalRecords={10}
                handleData={handleEquipmentRequestData}
                buttonText="Add"
                handleButtonClick={handleButtonClick}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
              {equipmentRequestData?.Data?.length > 0 && (
                <div className="save_and_next_div bottomButtons">
                  <Button onClick={() => navigate(EndPoints.EQUIPMENT_REQUEST)} className="button_save_and_next">View All</Button>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
        <ComponentDeleteModal
          show={showDeleteModal}
          setOpenFrom={() => setDeleteModal(false)}
          handleDelete={handleDeleteModal}
        />
      </div>
    </>
  );
}
